import { useNavigate } from 'react-router-dom'
import { resolveMediaUrl } from '../../../../utils/mediaUrl'

function initialsOf(name) {
  return String(name || 'U')
    .split(' ')
    .filter(Boolean)
    .slice(0, 2)
    .map((word) => word[0])
    .join('')
    .toUpperCase()
}

function PersonAvatar({ item }) {
  const avatar = resolveMediaUrl(item?.avatar)
  return (
    <div className="relative">
      {avatar ? (
        <img alt={item.alt || item.name || 'User'} className="h-10 w-10 rounded-full object-cover" src={avatar} />
      ) : (
        <div className="flex h-10 w-10 items-center justify-center rounded-full bg-primary/10 text-[11px] font-bold text-primary">
          {initialsOf(item?.name)}
        </div>
      )}
      {item.online ? (
        <span className="absolute bottom-0 right-0 h-2.5 w-2.5 rounded-full border-2 border-surface-container-low bg-green-500" />
      ) : null}
    </div>
  )
}

function SystemAvatar({ icon }) {
  return (
    <div className="flex h-10 w-10 items-center justify-center rounded-full bg-primary/10 text-primary">
      <span className="material-symbols-outlined text-lg">{icon || 'campaign'}</span>
    </div>
  )
}

function CommunicationRow({ item }) {
  return (
    <article className="flex cursor-pointer items-center gap-3 rounded-lg p-2 transition-colors hover:bg-surface-container-highest/50">
      {item.type === 'system' ? <SystemAvatar icon={item.icon} /> : <PersonAvatar item={item} />}

      <div className="min-w-0 flex-1">
        <div className="flex items-center justify-between gap-2">
          <p className="text-xs font-bold text-on-surface">{item.name}</p>
          <span className="text-[10px] text-on-surface-variant">{item.time}</span>
        </div>
        <p className="truncate text-[11px] text-on-surface-variant">{item.text}</p>
      </div>
    </article>
  )
}

export default function CommunicationsCard({ items }) {
  const navigate = useNavigate()
  const safeItems = Array.isArray(items) ? items : []

  return (
    <article className="flex min-h-[370px] flex-col overflow-hidden rounded-lg bg-surface-container-low">
      <div className="border-b border-surface-variant/30 p-6">
        <h3 className="text-[11px] font-semibold uppercase tracking-wider text-on-surface-variant">
          Communications
        </h3>
      </div>

      <div className="flex-1 space-y-4 overflow-y-auto p-4">
        {safeItems.length ? (
          safeItems.map((item, index) => (
            <CommunicationRow key={`${item.channelId || item.name}-${item.time}-${index}`} item={item} />
          ))
        ) : (
          <p className="px-2 text-[11px] text-on-surface-variant">No recent conversations.</p>
        )}
      </div>

      <div className="mt-auto p-4">
        <button
          type="button"
          onClick={() => navigate('/bridge/hub')}
          className="w-full rounded-md bg-secondary-container py-2 text-[11px] font-bold uppercase tracking-widest text-on-surface-variant transition-all hover:bg-primary-container hover:text-on-primary"
        >
          Open Inbox
        </button>
      </div>
    </article>
  )
}
